import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { AbstractControl } from '@angular/forms';

@Component({
  selector: 'antim-autoware-input',
  standalone: false,
  templateUrl: './input.component.html',
  styleUrl: './input.component.scss'
})
export class InputComponent {

  @Input() isRequired = false;
  @Input() classType = '';
  @Input() labelHide = false;
  @Input() labelValue = '';
  @Input() errorMessage = '';
  @Input() disabled = false;
  @Input() isMultiple = false;
  @Input() type = 'text';
  @Input() id = '';
  @Input() name = '';
  @Input() placeholder = '';
  @Input() min = '';
  @Input() control: AbstractControl | undefined;
  @Input() inputType: 'primary' | 'primaryWithoutBorder' | 'secondary' | 'secondaryWithoutBorder' | 'warning' | 'warningWithoutBorder' | 'success' | 'successWithoutBorder' | 'error' | 'errorWithoutBorder' = 'primary';
  @Output() onInputChangeEvent: EventEmitter<any> = new EventEmitter();
  @ViewChild('inputElement', { static: true }) inputElement!: ElementRef;
  @Output() blurEvent: EventEmitter<any> = new EventEmitter<any>(); // Emit blur event

  onInputChange($event: any) {
    this.onInputChangeEvent.emit($event.target.value);
  }

  getInputElement(): HTMLInputElement {
    return this.inputElement.nativeElement;
  }

  // Method to handle blur event
  onBlur($event: any): void {
    this.blurEvent.emit($event.target.value); // Emit blur event
  }
}
